import logo from './logo.svg';
import './App.css';
import Home from './components/home/Home';
import About from './components/about/About';
import Why from './components/why-choose-us/Why';
import Service from './components/service/Service';
import Feature from './components/feature/Feature';
import Testimonial from './components/testimonial/Testimonial';
import Apps from './components/apps/Apps';
import Footer from './components/footer/Footer';
import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import Product from './components/product/Product';
import Privacy from './components/privacy/Privacy';
import Whatsapp from './components/whatsapp/Whatsapp';
import Productpage from './pages/product/product';
import CartPage from './pages/CartPage/CartPage';
import Checkoutpage from './pages/CheckoutPage/CheckoutPage';
import Productdetails from './pages/ProductDetails/Productdetails';
import OrderHistory from './pages/Orders/Orders';

function App() {
  return (
    <Router>
      <Routes>

        <Route path='/' element={
          <>
            <Whatsapp />
            <Home />
            <About />
            <Why />
            <Service />
            <Feature />
            <Testimonial />
            <Apps />
            <Footer />
          </>
        } />

        <Route path='/privacy_policy' element={<Privacy />} />
        <Route path='/product' element={<Productpage />} />
        <Route path='/cart' element={<CartPage />} />
        <Route path='/checkout' element={<Checkoutpage />} />
        <Route path='/product-details/:id' element={<Productdetails />} />
        <Route path='/orders' element={<OrderHistory />} />

      </Routes>
    </Router>
  );
}

export default App;